module.exports = __webpack_public_path__ + "media/images/icons/icon-simulator-0195932a39e7f881840da71218162e24.svg";